import { KeyboardActionTrigger } from "../../hooks/useKeyboardActionTrigger";

const ACTION_TRIGGERS: Array<KeyboardActionTrigger> = [
  {
    type: 'press',
    key: 'z',
    modifiers: ['Control'],
    action: 'action-undo'
  },
  {
    type: 'press',
    key: 'z',
    modifiers: ['Meta'],
    action: 'action-undo'
  },
  {
    type: 'press',
    key: 'u',
    modifiers: [],
    action: 'action-set-measurement-as-unmeasurable'
  },
  {
    type: 'press',
    key: 'q',
    modifiers: [],
    action: 'action-set-measurement-as-unmeasurable'
  },
  {
    type: 'press',
    key: 'w',
    modifiers: [],
    action: 'action-pan-up'
  },
  {
    type: 'press',
    key: 'a',
    modifiers: [],
    action: 'action-pan-left'
  },
  {
    type: 'press',
    key: 's',
    modifiers: [],
    action: 'action-pan-down'
  },
  {
    type: 'press',
    key: 'd',
    modifiers: [],
    action: 'action-pan-right'
  },
]

export default ACTION_TRIGGERS;